import { SessionDeprecatedService } from '@commons/core/auth/session-deprecated.service';
import { RxUtil } from '@commons/util/utilities/rx';
import { IHttpService } from 'angular';
import { Observable } from 'rxjs';

import { RequestBuilder } from './request-builder';

export class AsObservableRequestBuilder extends RequestBuilder<Observable<any>> {
  /**
   * Creates an instance of RequestBuilder.
   * @param {IHttpService} http angular service
   * @param {string} baseUrl REST base URL
   * @param {any} sessionDeprecatedService session service
   */
  constructor(
    protected override readonly $http: IHttpService,
    protected override readonly sessionDeprecatedService: SessionDeprecatedService,
    protected override readonly baseUrl: string
  ) {
    super($http, sessionDeprecatedService, baseUrl);
  }

  get(path: string, pathParams?: (string | number | boolean)[]): Observable<any> {
    return RxUtil.fromPromise(() => this.$http.get(this.buildUrl(path, pathParams), this.config));
  }

  head(path: string, pathParams?: (string | number | boolean)[]): Observable<any> {
    return RxUtil.fromPromise(() => this.$http.head(this.buildUrl(path, pathParams), this.config));
  }

  post(path: string, pathParams?: (string | number | boolean)[]): Observable<any> {
    return RxUtil.fromPromise(() => this.$http.post(this.buildUrl(path, pathParams), this.data, this.config));
  }

  put(path: string, pathParams?: (string | number | boolean)[]): Observable<any> {
    return RxUtil.fromPromise(() => this.$http.put(this.buildUrl(path, pathParams), this.data, this.config));
  }

  delete(path: string, pathParams?: (string | number | boolean)[]): Observable<any> {
    return RxUtil.fromPromise(() => this.$http.delete(this.buildUrl(path, pathParams), this.config));
  }

  jsonp(path: string, pathParams?: (string | number | boolean)[]): Observable<any> {
    return RxUtil.fromPromise(() => this.$http.jsonp(this.buildUrl(path, pathParams), this.config));
  }

  patch(path: string, pathParams?: (string | number | boolean)[]): Observable<any> {
    return RxUtil.fromPromise(() => this.$http.patch(this.buildUrl(path, pathParams), this.data, this.config));
  }
}
